<template>
<div>
  <Modal
    v-model="isShow"
    :width="900"
    :loading="loading"
    :mask-closable="false"
  >
    <h3 slot="header" class="modal-header">添加特色标签</h3>
    <Form
			class="repeatForm"
			:ref="'form'+index"
			:model="itemP"
			:rules="ruleValidate"
			:label-width="90"
			v-for="(itemP,index) in labelEntities"
			:key="'index2'+index"
			>
      <Row >
				<Col span="7">
					<FormItem prop="labelName" label="标签名称">
						<Input v-model="itemP.labelName" placeholder="请输入不超过6个字"></Input>
					</FormItem>
				</Col>
				<Col span="7">
					<FormItem prop="labelSecondaryType" label="标签类型">
						<Select v-model="itemP.labelSecondaryType" placeholder="请选择">
              <Option value=''>请选择</Option>
              <Option v-for="(item,index1) in secondaryType" :key="'s1'+index1" :value="item.value">{{item.text}}</Option>
						</Select>
					</FormItem>
				</Col>
				<Col span="7">
					<FormItem prop="labelOrder" v-if="[1,3,4,5].indexOf(itemP.labelSecondaryType)>-1" label="显示顺序">
						<Input v-model="itemP.labelOrder" placeholder="请输入大于0的整数"></Input>
					</FormItem>
				</Col>
      </Row>
			<Row>
        <Col span="21">
          <FormItem label="背景图片">
            <Col style="float:left" v-if="itemP.picUrl" v-for="(item,index2) in itemP.picUrl" :key="'i1'+index2">
              <img class="upload" :src="item.attachmentImgUrl">
              <Button size="small" style="margin:0 8px 20px 0" @click="deleteImg(index2,index)">删除</Button>
            </Col>
           <Upload
            class="upload"
            :action="baseUrl+'/file/uploadFile'"
            :on-success="handleSuccess"
            :headers="{'Access-Token':token}"
						:data="{type:index}"
            :show-upload-list="false"
            :on-error="handleError"
            :format="['jpg','jpeg','png']"
            :on-format-error="formatError"
            icon="ios-cloud-upload-outline"
           >
           <Icon type="ios-plus-empty" size="30" style="vertical-align: middle"></Icon>
          </Upload>
          </FormItem>
        </Col>

				<Col span="2" v-if="index">
					<a style="line-height:32px;margin-left:10px" @click.stop="deleteItem(itemP,index)"> 删除</a>
				</Col>
      </Row>
    </Form>
		<!-- <Row>
			<Col span="4">
				<a style="line-height:32px;margin-left:10px" @click.stop="addItem"> + 继续添加</a>
			</Col>
		</Row> -->
		<Form
			ref="addData"
			:model="addData"
			:rules="ruleValidate2"
			:label-width="120">
      <Row class="max64">
        <Col span="7">
          <FormItem prop="applyType" label="适用对象">
            <Select v-model="addData.applyType" placeholder="请选择" :disabled="dis"  @on-change="changeType">
              <Option value=''>请选择</Option>
							<Option v-for="(item,index) in applyObject" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
						</Select>
          </FormItem>
        </Col>
				<Col span="10">
          <FormItem prop="projectHouseTypeFids" label="适用项目/房型">
            <Select v-model="addData.projectHouseTypeFids" placeholder="请选择" multiple filterable @on-change="selectProject">
							<Option value="all" v-if="addData.applyType">全部选择</Option>
							<Option v-if="addData.applyType==2" v-for="(item,index) in houseTypes" :key="'s3'+index" :value="item.value">{{item.text}}</Option>
							<Option v-if="addData.applyType==1" v-for="(item,index) in projects" :key="'s4'+index" :value="item.value">{{item.text}}</Option>
						</Select>
          	<span class="count" v-if="addData.projectHouseTypeFids.length">{{addData.projectHouseTypeFids.length}}</span>
          </FormItem>

        </Col>
      </Row>
    </Form>
		<div slot="footer">
      <Button type="text" size="large" @click="handleCancel">取消</Button>
      <Button type="primary" size="large" @click="ok">
        <span >保存</span>
      </Button>
    </div>
  </Modal>
	<Modal
		class="mask"
		v-model="isModalShow"
    :width="400"
    :loading="loading"
    :mask-closable="false"
		@on-ok="save"
    @on-cancel="cancel"
	>
		<h3 slot="header" class="modal-header">消息提醒</h3>
		<div class="tip">{{tips}}</div>
	</Modal>
	</div>
</template>

<script>
import {getToken} from "utils/auth";
import {getBaseUrl} from "utils/public";
import {saveOrEdit} from 'api/labelmanage'

export default {
	props:{
		n:{
			type:Number,
			default:0
		},
		secondaryType:{
			type:Array,
			default(){
        return []
      }
		},
		applyObject:{
			type:Array,
			default(){
        return []
      }
		},
		houseTypes:{
			type:Array,
			default(){
        return []
      }
		},
		projects:{
			type:Array,
			default(){
        return []
      }
		}
	},
  data(){
		const validates = (rule, value, callback) => {
			const pattern = /^\+?[1-9]\d*$/
			if (!pattern.test(value)) {
				callback(new Error('请填写显示顺序且为大于0的整数'));
			} else {
				callback();
			}
		};
		return{
			ruleValidate:{
        labelName:[
          { required: true, message: '请输入不超过6个字的标签名', max:6, trigger: 'blur',type:'string'}
				],
				labelSecondaryType:[
          { required: true, message: '请选择标签类型', trigger: 'change',type:'number'}
				],
        labelOrder:[
          { required: true, message: '请输入大于0的整数', trigger: 'blur',type:'number',validator: validates}
        ],
			},
			ruleValidate2:{
				applyType:[
					{ required: true, message: '请选择适用对象', trigger: 'change',type:'number'}
				],
				projectHouseTypeFids:[
					{ required: true, message: '请选择适用项目/房型', trigger: 'change',type:'array'}
				]
			},
			token:'',
      baseUrl:'',
			loading:false,
			isShow:false,
			addData:{
				applyType:'',
				projectHouseTypeFids:[]
			},
			isModalShow:false,
			tips:'提交后标签将在页面上显示！',
			itemP:[],
			labelEntities:[],
      picUrl:[],
			maxnum:1,
			imgIndex:0,
			selectedAll:false,
			dis:false,
		}
	},
	created() {
    this.baseUrl = getBaseUrl()
    this.token = getToken()
  },
	watch:{
		n(){
			if(this.$refs['form0']){
        this.$refs['form0'][0].resetFields()
      }
			this.$refs['addData'].resetFields()
			this.labelEntities =[
        {
					labelType:4,
          labelName:'',
          labelOrder:'',
          labelSecondaryType:'',
          picUrl:[],
        }
      ],
			this.isShow = true;
		},
		labelEntities:{
			deep:true,
			handler(val){
				if([4,5].indexOf(val[0].labelSecondaryType)>-1){
					this.addData.applyType = 1
					this.dis = true
				} else{
					this.dis = false
				}
			}
		}
	},
	methods:{
		changeType(){
			this.selectedAll = false
		},
		selectProject(value){
			let isCheck = false
			value.forEach(ele=>{
				if(ele==='all'){
					isCheck = true
					this.selectedAll = !this.selectedAll
				}
			})
			if(isCheck&&this.selectedAll){
				const val = []
				if(this.addData.applyType === 1){
					this.projects.forEach(ele=>{
						val.push(ele.value)
					})
				}
				if(this.addData.applyType === 2){
					this.houseTypes.forEach(ele=>{
						val.push(ele.value)
					})
				}
				this.addData.projectHouseTypeFids = val;
			}
			if(isCheck && !this.selectedAll){
				this.addData.projectHouseTypeFids = []
			}
		},
		deleteImg(index2,indexP){
			this.labelEntities.forEach((ele,index)=>{
				if(index == indexP){
					ele.picUrl.splice(index2,1)
				}
			})
    },
		handleSuccess(res){
			const index = res.data.type;
			if(this.labelEntities[index].picUrl.length>=this.maxnum ){
					this.$Message.error('最多上传'+this.maxnum+'张图片')
					this.changeLoading();
					return
			}
			this.labelEntities[index].picUrl.push({
				fid:res.data.fid,
				attachmentImgUrl:res.data.url
			})

		},
		formatError(){
      this.$Message.info('请上传jpg、jpeg、png类型文件')
    },
		handleError(){

    },
		deleteItem(item,index){
      this.$Modal.confirm({
        content: '<p>确认删除？</p>',
        onOk:() => {
          this.labelEntities.splice(index,1)
        }
      })
		},
		addItem(){
      this.labelEntities.push(
        {
					labelType:4,
          labelName:'',
          labelOrder:'',
          labelSecondaryType:'',
          picUrl:[],
        }
      )
    },
		ok(){
      let validate = true
      for (const i in this.$refs) {
        if(this.$refs[i] instanceof Array){
          this.$refs[i].forEach(item => {
            item.validate(bool => {
              !bool && (validate = bool)
            })
          })
        }
      }
      this.$refs['addData'].validate( bool => {
        if(bool){

        } else{
          validate = false
          this.changeLoading();
        }
      })
      if (!validate) {
        this.changeLoading()
        return
			}
			this.isModalShow = true
    },
		save(){
			const params = {
				labelEntities:this.labelEntities,
				...this.addData
			}
			saveOrEdit(params)
			.then(res=>{
				if(res.code === 0){
					this.$emit('done')
					this.$Message.success('保存成功')
				} else{
					// this.$Message.error('保存失败')
				}
			})
			.catch(err=>{
				// this.$Message.error('保存失败')
			})
			.finally(()=>{
				this.isModalShow = false
				this.isShow = false;
			})
		},
		cancel(){
			this.isModalShow = false
		},
		handleCancel(){
			this.isShow = false;
		},
		changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
	}
}
</script>

<style scoped>
.tip{
	font-size: 13px;
	text-align: center;
}
.upload {
    display: inline-block;
    width: 60px;
    height: 40px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
		line-height: 40px;
  }
	.repeatForm{
		padding-top: 24px;
		width: 100%;
		height: auto;
		border: 1px dashed darkgrey;
		margin-bottom: 20px;
	}
	  .count {
    display: inline-block;
    min-width: 16px;
    min-height: 16px;
    position: absolute;
    top: -6px;
    right: -6px;
    background: #cfa868;
    color: #ffffff;
    border-radius: 100%;
    line-height: 15px;
    text-align: center;
    font-weight: 600;
  }
</style>